import { candidateMailReplaceTokens, legacyCandidateMailReplaceTokens } from '../constants';

export const mailVariableLabels = new Map(
  [...candidateMailReplaceTokens, ...legacyCandidateMailReplaceTokens].map((token) => [
    token.token,
    token.label,
  ])
);

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const mailVariablePattern = new RegExp(
  `(${[...mailVariableLabels.keys()].map(escapeRegExp).join('|')})`,
  'g'
);

export const splitMailVariables = (value: string) => value.split(mailVariablePattern);

export const countMailVariables = (value: string) => value.match(mailVariablePattern)?.length ?? 0;

export const mailVariableChipClassName =
  'mx-xxs inline-flex h-5 items-center rounded-full bg-tag-blue px-sm align-middle text-tag-sm leading-none whitespace-nowrap text-tag-blue';
